import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormatterType } from '../components/input-field/input-field.component';
import { AuthService } from 'src/app/auth/auth.service';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';

@Component({
  selector: 'contact-support-form',
  templateUrl: './contact-support-form.component.html',
  styleUrls: ['./contact-support-form.component.scss']
})
export class ContactSupportFormComponent implements OnInit {
  private static SUPPORT_EMAIL = 'mailto:support@myvessel.com';

  public emailType = FormatterType.EMAIL;
  public userNameType = FormatterType.NAME;
  public apartmentsType = FormatterType.NUMBER;
  public buildingsList = ['Cheshire', 'New London', 'Simsbury', 'Trenton'];

  @Input() openModal!: EventEmitter<boolean>;

  public prefill: boolean = false;

  public username: string = '';
  public email: string = '';
  public apartments: string = '';
  public building: string = '';
  public messageText: string = '';

  public invalidUserName: boolean = false;
  public invalidEmali: boolean = false;
  public invalidApartments: boolean = false;
  public invalidBuilding: boolean = false;
  public invalidMessageText: boolean = false;

  constructor(private authService: AuthService) {}

  public ngOnInit(): void {
    this.openModal.subscribe((isOpen: boolean) => {
      if (isOpen) {
        this.authService.getUserAttributes(
          (err: any) => {},
          (res: CognitoUserAttribute[] | undefined) => { 
            if (res) {
              this.prefill = true;
              const given_name = res?.find(el => el.Name == 'given_name');
              const family_name = res?.find(el => el.Name == 'family_name');
              this.username = `${given_name ? given_name.Value : ''} ${family_name ? family_name.Value : ''}`;
      
              this.email = res?.find(el => el.Name == 'email')?.Value || '';
            }
          }
        );
      }
    })
  }

  public sendMessage() {
    if (this.checkFormValid()) {
      const subject = encodeURI(`Apartment ${this.apartments}, ${this.building}`);
      const body = encodeURI(`${this.username}
        Contact email: ${this.email}

        ${this.messageText}
      `);
      const mailUrl = `${ContactSupportFormComponent.SUPPORT_EMAIL}?subject=${subject}&body=${body}`;

      window.open(mailUrl, '_blank');
      this.closeForm();
    } 
  }

  public checkFormValid(): boolean {
    this.invalidUserName = !this.username?.length;
    this.invalidEmali = !this.email?.length;
    this.invalidApartments = !this.apartments?.length;
    this.invalidBuilding = !this.building?.length;
    this.invalidMessageText = !this.messageText?.length;
    return !this.invalidUserName && !this.invalidEmali && !this.invalidApartments && !this.invalidBuilding && !this.invalidMessageText;
  }

  public closeForm() {
    if (!!this.openModal) {
      this.openModal.emit(false);
    }

    this.username = '';
    this.email = '';
    this.apartments = '';
    this.building = '';
    this.messageText = '';
  }
}
